// Logica pura do formulario unico de agendamento (decisao 18 do kanban-layout-r3).
// Fica fora do componente para poder ser testada sem montar o Vue.

// Duracao tem tres nomes no JSON conforme a tela que gravou. Escrever sempre
// duration_min e duration_minutes; ler os tres.
export const readDurationMin = source => {
  if (!source) return null;
  const value =
    source.duration_min ?? source.duration_minutes ?? source.durationMin;
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

// Responsavel ja vem preenchido: dono do cartao quando existe, senao o usuario
// da sessao. Deixa de exigir escolha manual.
export const defaultResponsibleId = ({
  itemResponsibleId = null,
  currentUserId = null,
} = {}) => {
  if (itemResponsibleId != null && itemResponsibleId !== '') {
    return itemResponsibleId;
  }
  if (currentUserId == null || currentUserId === '') return null;
  return currentUserId;
};

// A conferencia so aparece quando de fato vai sair mensagem para o cliente.
export const shouldReview = ({
  wahaEnabled = false,
  hasPhone = false,
  hasKanbanItem = false,
  sendWhats = false,
} = {}) => Boolean(wahaEnabled && hasPhone && hasKanbanItem && sendWhats);

// Linha de contexto do topo: "Com <contato> · cartao <titulo> · <funil>".
// Recebe os trechos ja traduzidos e so decide o que entra e a ordem.
export const contextLine = ({
  contactLabel = '',
  cardLabel = '',
  funnelName = '',
} = {}) => [contactLabel, cardLabel, funnelName].filter(Boolean).join(' · ');

// Payload unico emitido pelo formulario. O pai decide para onde grava, mas o
// formato e sempre este.
export const buildSchedulePayload = ({
  item = null,
  scheduledAt = '',
  durationMin = 30,
  title = '',
  responsibleId = null,
  responsibleName = '',
  location = '',
  contactId = null,
  kanbanItemId = null,
  sendWhats = false,
  googleCalendarConnectionId = null,
} = {}) => {
  const payload = {
    item,
    scheduledAt,
    durationMin,
    title,
    responsibleId,
    location,
    contactId,
    kanbanItemId,
    sendWhats: Boolean(sendWhats),
    confirmation: {
      scheduled_at: scheduledAt,
      duration_minutes: durationMin,
      location,
      responsible_name: responsibleName,
    },
  };
  if (googleCalendarConnectionId) {
    payload.googleCalendarConnectionId = googleCalendarConnectionId;
  }
  return payload;
};

// Linha SOMENTE LEITURA do destino no Google (decisao 1 da rodada de fechamento).
// Nao existe opt-out: GoogleCalendar::PushEventJob#resolve_connection publica
// pela conexao do funil mesmo sem destino explicito. Entao a tela nao oferece
// chave nenhuma, ela conta o que vai acontecer.
//
// Tres estados, e o terceiro importa:
//   google  -> tem destino (explicito, ou a conexao usavel do funil)
//   local   -> conferimos e nao ha nenhum destino
//   unknown -> ainda nao da para afirmar (sem funil conhecido, ou status em voo).
//              Nesse caso a tela nao escreve nada: "fica so no SiteUP CRM" seria
//              um palpite, e o backend ainda tem o caminho legado pelo contato.
export const GOOGLE_DESTINATION = {
  GOOGLE: 'google',
  LOCAL: 'local',
  UNKNOWN: 'unknown',
};

export const googleDestination = ({
  explicitLabel = '',
  funnelStatus = 'unknown',
  funnelLabel = '',
} = {}) => {
  if (explicitLabel) {
    return { mode: GOOGLE_DESTINATION.GOOGLE, label: explicitLabel };
  }
  if (funnelStatus === 'connected') {
    return { mode: GOOGLE_DESTINATION.GOOGLE, label: funnelLabel };
  }
  if (funnelStatus === 'none') {
    return { mode: GOOGLE_DESTINATION.LOCAL, label: '' };
  }
  return { mode: GOOGLE_DESTINATION.UNKNOWN, label: '' };
};
